export default __webpack_public_path__ + "static/media/play.284279f2.png";